import { MessageService } from './../../services/message.service';
import {
  Component,
  OnDestroy,
  OnInit,
  ComponentRef,
  Input,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import * as type from '../../shared/action.event';
import { SearchService } from '../../services/search.service';
import { Router, ActivatedRoute, NavigationEnd, ParamMap } from '@angular/router';
import { ProductDetailComponent } from '../../product/productdetail/product.detail.component';
import {
  BrandListReturn,
  MetaModel,
} from '../../models/search-brand-result.model';
import { getStockOnHand } from '../../shared/tools.collections';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { Subscription } from 'rxjs';
import { ShoppingCart } from '../../models/shopping-cart.model';
import { CommonService } from '../../services/common.service';
import { ApiResponse } from '../../models/api-response.model';
import { EventListenerService } from '../../services/close-listenenr.service';
import { FormControl, NgModel } from '@angular/forms';
import { ProductDetail } from '../../models/product-detail.model';
import { FilterPipe } from '../../shared/filter.pipe';
import { sortingInfo } from '../../models/filter.model';
import { Subject } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { filter, takeUntil } from 'rxjs/operators';
import { NgProgressService } from '../../services/ngProgress.service';


declare var jquery: any;
declare var $: any;

@Component({
  selector: 'search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.css']
})
export class SearchResultComponent implements OnInit, OnDestroy {
  title = 'Results';
  p = 1;
  closesub$;
  // the next level componnent
  component: ComponentRef<ProductDetailComponent>;

  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;
  helpComponent: ComponentRef<any>;

  searchResult: BrandListReturn[];
  sortedData: BrandListReturn[];

  searchBrands: MetaModel;
  fixedSearchResult: BrandListReturn[];
  fixedSearchBrands: MetaModel;

  searchedKeyword = undefined;

  subscriptionShoppingCartService: Subscription;
  subscriptionCartIdService: Subscription;
  subscriptionSearchParaWatcher: Subscription;
  shoppingCarts: ShoppingCart[];
  cartId: number;

  buyButtonClicked: boolean = false;
  loadContent: boolean = false;

  inputQty: string = '1';
  inputQtyArr: { [K: string]: string } = {};

  //Declare filter variables
  brands = new FormControl();
  selectedBrands = [];
  types = new FormControl();
  selectedTypes = [];
  categories = new FormControl();
  selectedCategories = [];
  serieses = new FormControl();
  selectedSeriese = [];

  fixedBrandList = [];
  fixedTypeList = [];
  fixedCatList = [];
  fixedSerList = [];

  hasBrandAutoSelected: boolean = false;
  hasTypeAutoSelected: boolean = false;
  hasCatAutoSelected: boolean = false;
  hasSerAutoSelected: boolean = false;


  filterInput = '';
  filterResultArr = undefined;

  hasEmptyResult: boolean = true;
  searchProductClicked: boolean = false;
  globallySearch: boolean = false;
  hasEmptyFilterResult: boolean = false;
  searchValueChange: boolean = false;

  productDetailModel: ProductDetail;

  //search params
  brandsParams: string = '';
  typesParams: string = '';
  catsParams: string = '';
  seriesParams: string = '';
  minPrice: string = '';
  maxPrice: string = '';
  minSOH: string = '';

  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  @Input() searchFiled: string;
  typeList = [];
  categoryList = [];
  seriesList = [];

  sortingInfoObj: sortingInfo = {
    comparedProperty: '',
    sortingOrder: ''
  };

  testingString: number = 1;

  constructor(
    private closeService: EventListenerService,
    private searchService: SearchService,
    private router: Router,
    private activeRouter: ActivatedRoute,
    public ngProgress: NgProgressService,
    private shoppingCartService: ShoppingCartService,
    private commonService: CommonService,
    private messageService: MessageService
  ) {

  }

    ngOnInit() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd )).subscribe(res => {
            if(this.router.url === '/buy' && this.buyButtonClicked){
                $('.page-contents').animate({ scrollLeft: -$('#levelOne').outerWidth() }, 400);
                this.buyButtonClicked = false;
            }
        });
        const param = this.activeRouter.snapshot.paramMap.get('searchparm');
      
        let searchValue = decodeURIComponent(param);
        this.searchService.monitorSearchValueChange(searchValue);
        this.loadContent = false;

        if (this.router.url !== `/buy/result/${searchValue}`) {
            this.loadContent = true;  //set to true to avoid load two loading screen at the same time
        }

        if (searchValue) {
            
            this.ngProgress.start();
            this.searchBrands = null;
            this.searchResult = [];
            if(!this.searchProductClicked){
                this.subscriptionSearchParaWatcher = this.searchService.currentWatch.pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                    (res: string) => {   
                        this.doSearch(res);
                    },
                   (error: any) => { console.error(error); });
             }

            // add the value of searchValue to the inside of the input box in the blade
            this.searchedKeyword = searchValue;
            this.ngProgress.done();
        }

    this.closesub$ = this.closeService.close.subscribe(value => {
      if (value === type.PRODUCT) {
        if (this.component) {
          this.component.destroy();
        }
      }
    },
      (error: any) => { console.error(error); });

    this.subscriptionShoppingCartService = this
      .shoppingCartService
      .getShoppingCart().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(sc => {
        this.shoppingCarts = sc;
      },
        (error: any) => { console.error(error); });

    this.subscriptionCartIdService = this
      .shoppingCartService
      .currentCartId
      .subscribe(cn => {
        this.cartId = cn;
      },
        (error: any) => { console.error(error); });
  }


  doSearch(res: string) {

    this.filterReset();
    this.globallySearch = false;
    this.hasEmptyResult = true;
    this.loadContent= false;
    

    this.searchService.retrieve(res.trim(), this.brandsParams, this.typesParams, this.catsParams, this.seriesParams, this.minPrice, this.maxPrice, this.minSOH).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(
        model => {
            //console.log('watch keyword changes - start Observable');
            this.fixedSearchBrands = model.meta;
            this.fixedSearchResult = model.data;
            
            this.searchedKeyword = res.trim();
            this.searchResult = model.data;
            this.sortedData = model.lr_record_count > 0 ? this.searchResult.slice() : null;
            this.searchBrands = model.meta;
            //console.log(this.sortedData);

            if (!this.sortedData) this.hasEmptyFilterResult = true;

            this.globallySearch = true;
            if (this.fixedSearchBrands){
              this.fixedBrandList = this.fixedSearchBrands.brand.map((item) => {
                return item.lr_stk_brand === '' ? 'UNKNOWN' : item.lr_stk_brand;
              });
              this.fixedTypeList = this.fixedSearchBrands.primary.map((item) => {
                return item.lr_primary_cat === '' ? 'UNKNOWN' : item.lr_primary_cat;
              });
              this.fixedCatList = this.fixedSearchBrands.secondary.map((item) => {
                return item.lr_secondary_cat === '' ? 'UNKNOWN' : item.lr_secondary_cat;
              });
              this.fixedSerList = this.fixedSearchBrands.tertiary.map((item) => {
                return item.lr_tertiary_cat === '' ? 'UNKNOWN' : item.lr_tertiary_cat;
              });

              this.fixedBrandList.push('all');
              this.fixedTypeList.push('all');
              this.fixedCatList.push('all');
              this.fixedSerList.push('all');
            }

            if (!this.searchBrands) {
              this.hasEmptyResult = false;
            } else if (this.searchBrands.lr_total_count !== "-1" && this.searchBrands.lr_total_count !== "0") {
              this.hasEmptyResult = false;
            }

            this.setInputQtyArr();

            this.loadContent = true;

        },
        error => console.log("Error: ", error),
        () => {
            this.globallySearch = true;
            //console.log('onComplete Observable');
            //console.log(this.searchResult);
          }
      );
  }

  sortData(sort: Sort) {
    const data = this.searchResult.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedData = data;
    }

    this.sortedData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'des': return compare(a.lr_stk_description, b.lr_stk_description, isAsc);
        case 'soh': return compare(a.lr_avail_qty, b.lr_avail_qty, isAsc);
        case 'price': return compare(parseFloat(a.lr_stk_price), parseFloat(b.lr_stk_price), isAsc);
        case 'qty': return compare(a.lr_stock_code, b.lr_stock_code, isAsc);
        default: return 0;
      }
    });
  }

  checkingArr(array): boolean {
    if (typeof array != "undefined" && array != null
    ) {
      if (array.length != null && array.length > 0) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  setInputQtyArr() {
    if (this.searchResult) {
      for (let i = 0; i < this.searchResult.length; i++) {
        this.inputQtyArr[this.searchResult[i]["lr_stock_code"]] = "DDL";
      }
    }
  }

  filterReset(): void {

    this.hasEmptyFilterResult = false;
    this.filterResultArr = undefined;

    this.selectedBrands = [];
    this.selectedTypes = [];
    this.selectedCategories = [];
    this.selectedSeriese = [];

    this.filterInput = '';

    this.sortingInfoObj.comparedProperty = '';
    this.sortingInfoObj.sortingOrder = '';
  }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();  

        this.closesub$.unsubscribe();
        this.subscriptionShoppingCartService.unsubscribe();
        this.subscriptionCartIdService.unsubscribe();
        this.subscriptionSearchParaWatcher.unsubscribe();
        
    }

    pageChange(event: any) {
        this.ngOnDestroy();
        //console.log("page changes");
        $('.page-contents').animate({ scrollLeft: $('#levelOne').width() }, 400);
        //console.log('now change the page : ', event);
    }

    reloadProductDetailComponent(newSku: string){
        // if navigated at the same URL, call the Jquery animate() method. 
        let currentURL = this.router.url;
        let currentSku = currentURL.substring(currentURL.lastIndexOf('/')+1)
        if(currentSku === newSku){
            //console.log("reloading");
            $('.page-contents').animate(
                { scrollLeft: $('#levelOne').outerWidth() + $('#subBlock').outerWidth() },
                400
            );
        }
    }

    close() { 
        
        $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
        this.router.navigateByUrl('/buy');
    }

  addToCart(event, brandItem: BrandListReturn) {

    event.stopPropagation();
    event.preventDefault();
    this.ngProgress.start();

    this.shoppingCartService.addItemToShoppingCart(brandItem.lr_stock_code, this.cartId, this.inputQtyArr[brandItem.lr_stock_code]).subscribe((data: ApiResponse) => {
      if (data.status) {
        this.commonService.implementToast(data.responseMessage, 'Success');
        // this.commonService.showSuccess('#addcartbtn' + brandItem.lr_stock_code, data.responseMessage, 'left');
        this.shoppingCartService
          .getShoppingCart()
          .subscribe((sc: ShoppingCart[]) => {
            this.shoppingCartService.monitorNumberOfItemsChange(sc.filter(cart => cart.cartId.toString() == this.commonService.readCookie('CartId'))[0].totalQuantity);
          },
            (error: any) => {
              console.error(error);
              this.ngProgress.done();
            });
        this.ngProgress.done();
      } else {
        this.commonService.implementToast(data.responseMessage, 'Error');

        // this.commonService.showError('#addcartbtn' + brandItem.lr_stock_code, data.responseMessage, 'left');
        this.ngProgress.done();
      }
    },
      (error: any) => {
        this.commonService.implementToast(error.responseMessage, 'Error');

        // this.commonService.showError('#addcartbtn' + brandItem.lr_stock_code, error.responseMessage, 'right');
        this.ngProgress.done();
      });
  }

  sohLoad(current: string, max: string): string {
    return getStockOnHand(current, max, null, null, null);
  }

  sendFeedback(event: any) {
    event.stopPropagation();
    this.messageService.filter('feedback');
  }


  onClicked(message: string): void {
    if (message === 'clicked') {
      this.buyButtonClicked = true;
    }
  }

  //called when the mat-select has any changes.
  updateFilterList(seletedFilter, fixedFilterList, allSelect, hasAutoSelected, filterName) {
    if (seletedFilter.includes('all') && seletedFilter.length === (fixedFilterList.length - 1)) {
      allSelect.deselect();
    }
    //if 'All' option is selected, but user deselect any other option => 'All' option will be deselected by default. 
    else if ((seletedFilter.length <= fixedFilterList.length) && allSelect.selected && seletedFilter.length != 1 && !hasAutoSelected) {
      allSelect.deselect();
      if (filterName === 'brand') {
        this.hasBrandAutoSelected = false;
      } else if (filterName === 'type') {
        this.hasTypeAutoSelected = false;
      } else if (filterName === 'category') {
        this.hasCatAutoSelected = false;
      } else {
        this.hasSerAutoSelected = false;
      }
      return;
    }
    //if All option is deselected, but the rest options are selected. => 'All' option will be selected by default.
    else if ((seletedFilter.length === (fixedFilterList.length - 1)) && !seletedFilter.includes('all')) {
      allSelect.select();
      if (filterName === 'brand') {
        this.hasBrandAutoSelected = true;
      } else if (filterName === 'type') {
        this.hasTypeAutoSelected = true;
      } else if (filterName === 'category') {
        this.hasCatAutoSelected = true;
      } else {
        this.hasSerAutoSelected = true;
      }
      return;
    }

  }

  //called when All option is clicked
  toggleAllSelection(seletedFilter, selectedFilterValues: NgModel, comparedFixedList: string[], allSelected) {
    //Condition 1: every option (include 'All') is selected and click the All option
    if (seletedFilter.length === (comparedFixedList.length)) {
      selectedFilterValues.update.emit([]);
    }
    //Condition 2: 'All' option is deselected and at least one other option is selected
    else if (!allSelected.selected) {
      selectedFilterValues.update.emit(comparedFixedList);
    }
    //Condition 3: None of options are selected and click the All option
    else if (allSelected.selected && seletedFilter.length === 1) {
      selectedFilterValues.update.emit(comparedFixedList);
    }
    else if ((allSelected.selected && seletedFilter.length > 1) &&
      (seletedFilter.includes('all') && seletedFilter.length < comparedFixedList.length) || (!seletedFilter.includes('all') && seletedFilter.length < (comparedFixedList.length - 1))) {
      selectedFilterValues.update.emit(comparedFixedList);
    }
    else {
      selectedFilterValues.update.emit([]);
    }
  }

  tickAllOptionsByOpeningPanel(event, fixedFilterList, selectedFilterValues: NgModel, seletedFilter) {
    //check if the panel is opened
    if ($(event.target).closest('.mat-input-flex.mat-form-field-flex').length) {
      if (seletedFilter.length === 0) {
        selectedFilterValues.update.emit(fixedFilterList);
      }
    }
  }

    openedChange(opened: boolean, allSelected, selectedFilterValues: NgModel){
        if(!opened){
          if(allSelected.selected){
            selectedFilterValues.update.emit([]);
          }
        }
    }
    onChange(){
        this.filterResultArr = new FilterPipe().transform(this.sortedData,  this.selectedBrands, this.selectedTypes, this.selectedCategories, this.selectedSeriese, this.filterInput);
        if(this.filterResultArr.length === 0){
          this.hasEmptyFilterResult = true;
    
        }else{
          this.hasEmptyFilterResult = false;
        }
    }
    
    onLoading(currentLoadingStatus: boolean) {
   
        this.loadContent = !currentLoadingStatus;
    }
     
    checkProductDetail(stockCode: string): void {
      stockCode = encodeURIComponent(stockCode);
      this.router.navigate([`product/${stockCode}`], { relativeTo: this.activeRouter });
  }

    sortByDescendAscend(comparedProperty:string, sortingOrder: string){
        this.testingString ++;
        switch (comparedProperty){
            case 'description':
                this.sortingInfoObj.comparedProperty = 'description';
            break;
            // --------------------------------------------------------------------------------------
            case 'soh':
                this.sortingInfoObj.comparedProperty = 'soh';
            break;
            // --------------------------------------------------------------------------------------
            case 'price':
                this.sortingInfoObj.comparedProperty = 'price';
            break;
        }

    if (sortingOrder === "descending") {
      this.sortingInfoObj.sortingOrder = 'descending';
    } else {
      this.sortingInfoObj.sortingOrder = 'ascending'
    }
  }
}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
